# type: indicate the button type, Posibbles types: 1: color blue, hover yellow; 2: color white, hover yellow. (integer)
# route: machine name of the route where the button should link to. (string)
# text: text to use as the value of the link (button). (string)
# disable: verify if there is a case the button need to be disabled (boolean)
<template>
  <RouterLink
    :event="!disabled ? 'click' : ''"
    :to="{ name: route, params: routeParams }"
    class="TMGeneralButton"
    :class="className"
  >
    <b>{{ text }}</b>
  </RouterLink>
</template>
<script>
module.exports = {
  props: ["text", "className", "route", "routeParams", "disabled"],
};
</script>
<style lang="less" >
@import "../../assets/components/common/TMGeneralButton.less";
</style>;
